import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as productApi from '../../lib/api/product';

const [
  LIST_PRODCUT_PRICES,
  LIST_PRODCUT_PRICES_SUCCESS,
  LIST_PRODCUT_PRICES_FAILURE,
] = createRequestActionTypes('product/LIST_PRODCUT_PRICES');

export const listProductPrices = createAction(LIST_PRODCUT_PRICES, (id) => id);
const listProductPricesSaga = createRequestSaga(
  LIST_PRODCUT_PRICES,
  productApi.getProductPrices,
);

const UNLOAD_PRICES = 'product/UNLOAD_PRICES';
export const unloadPrices = createAction(UNLOAD_PRICES);

export function* productPricesSaga() {
  yield takeLatest(LIST_PRODCUT_PRICES, listProductPricesSaga);
}

const initialState = {
  prices: null,
  error: null,
};

const productPrices = handleActions(
  {
    [LIST_PRODCUT_PRICES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      prices: data.list.map((price) => ({
        id: price.priceUuid,
        priceUuid: price.priceUuid,
        productUuid: price.productUuid,
        partnerUuid:price.partnerUuid,
        partnerNm:price.partnerNm,
        priceTyp: price.priceTyp,
        priceVal: price.priceVal,
        priceDesc:price.priceDesc,
        useYn: price.useYn === 'Y' ? true : false,
        crtNm: price.crtNm,
        crtDt: price.crtDt,
        cngNm: price.cngNm,
        cngDt: price.cngDt,
      })),
      error: null,
    }),
    [LIST_PRODCUT_PRICES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PRICES]: () => initialState,
  },
  initialState,
);

export default productPrices;
